import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccount = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Laag_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 16.9 16.4",
	style: { enableBackground: "new 0 0 16.9 16.4" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("filter", {
			id: "Adobe_OpacityMaskFilter",
			filterUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 16.9,
			height: 16.4,
			children: /* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
			})
		}) }),
		/* @__PURE__ */ _jsx("mask", {
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 16.9,
			height: 16.4,
			id: "mask0_308_29124_00000125599971887896530160000010684842963358601904_",
			children: /* @__PURE__ */ _jsx("rect", {
				x: -5.1,
				y: -5.3,
				className: "st0",
				width: 27,
				height: 27
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			className: "st1",
			children: /* @__PURE__ */ _jsx("path", {
				className: "st2",
				d: "M8.4,7.9c-1.1,0-2-0.4-2.8-1.2C4.9,5.9,4.5,5,4.5,3.9c0-1.1,0.4-2,1.2-2.8C6.4,0.4,7.4,0,8.4,0s2,0.4,2.8,1.2 c0.8,0.8,1.2,1.7,1.2,2.8c0,1.1-0.4,2-1.2,2.8C10.4,7.5,9.5,7.9,8.4,7.9z M0,16.4v-2.5c0-0.6,0.1-1.1,0.4-1.5 c0.3-0.5,0.7-0.8,1.2-1.1c1.1-0.5,2.2-1,3.4-1.2c1.1-0.3,2.3-0.4,3.4-0.4c1.2,0,2.3,0.1,3.4,0.4s2.3,0.7,3.4,1.2 c0.5,0.3,0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.5v2.5H0z M1.7,14.8h13.5v-0.8c0-0.2-0.1-0.4-0.2-0.6s-0.3-0.4-0.5-0.5 c-1-0.5-2-0.8-3-1.1c-1-0.2-2-0.4-3-0.4c-1,0-2,0.1-3,0.4c-1,0.2-2,0.6-3,1.1C2.2,13,2,13.1,1.9,13.3c-0.1,0.2-0.2,0.4-0.2,0.6 V14.8z M8.4,6.2C9.1,6.2,9.6,6,10,5.5c0.4-0.4,0.7-1,0.7-1.6S10.5,2.8,10,2.3c-0.4-0.4-1-0.7-1.6-0.7c-0.6,0-1.1,0.2-1.6,0.7 c-0.4,0.4-0.7,1-0.7,1.6s0.2,1.1,0.7,1.6C7.3,6,7.8,6.2,8.4,6.2z",
				fill: "currentColor"
			})
		})
	]
});
export { SvgAccount as ReactComponent };
